import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TopNavBar from '../dashboard/components/TopNavBar';
import Icon from '../../components/AppIcon';
import ChartOfAccountsTab from '../admin-dashboard/components/accounting/ChartOfAccountsTab';
import BankMasterTab from '../admin-dashboard/components/accounting/BankMasterTab';
import VendorMasterTab from '../admin-dashboard/components/accounting/VendorMasterTab';
import ExpenseMasterTab from '../admin-dashboard/components/accounting/ExpenseMasterTab';
import FixedAssetMasterTab from '../admin-dashboard/components/accounting/FixedAssetMasterTab';
import TransactionsTab from '../admin-dashboard/components/accounting/TransactionsTab';
import ReportsTab from '../admin-dashboard/components/accounting/ReportsTab';
import NavigationPreventer from '../../components/NavigationPreventer';
import { useAuth } from '../../state/auth/useAuth';

const AccountingPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('reports');
  const [activeSubTab, setActiveSubTab] = useState('chart-of-accounts');

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    switch(tabId) {
      case 'dashboard':
        navigate('/dashboard');
        break;
      case 'master-data':
        navigate('/admin/dashboard');
        break;
      case 'patients':
        navigate('/users');
        break;
      case 'inventory':
        navigate('/inventory');
        break;
      case 'reports':
        // Stay on accounting/reports page
        break;
      case 'finance':
        navigate('/finance');
        break;
      case 'settings':
        navigate('/hospital-settings');
        break;
      case 'profile':
        console.log('Profile navigation - route not yet configured');
        break;
      default:
        break;
    }
  };

  const accountingTabs = [
    { id: 'chart-of-accounts', label: 'Chart of Accounts', icon: 'FileText', component: ChartOfAccountsTab },
    { id: 'bank-master', label: 'Bank Accounts', icon: 'CreditCard', component: BankMasterTab },
    { id: 'vendor-master', label: 'Vendors', icon: 'Users', component: VendorMasterTab },
    { id: 'expense-master', label: 'Expenses', icon: 'Receipt', component: ExpenseMasterTab },
    { id: 'fixed-assets', label: 'Fixed Assets', icon: 'Archive', component: FixedAssetMasterTab },
    { id: 'transactions', label: 'Transactions', icon: 'ArrowLeftRight', component: TransactionsTab },
    { id: 'reports', label: 'Reports', icon: 'BarChart3', component: ReportsTab }
  ];

  const Current = accountingTabs.find(t => t.id === activeSubTab)?.component || ChartOfAccountsTab;

  return (
    <div className="min-h-screen bg-gray-50">
      <NavigationPreventer />
      <TopNavBar 
        user={user}
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />
      <main className="pt-20 px-4 lg:px-6">
        <div className="space-y-6">
          <div className="bg-white rounded-lg border shadow-sm p-6">
            <h1 className="text-3xl font-bold text-gray-900 mb-1 flex items-center gap-2">
              <Icon name="Calculator" size={28} />
              Accounting
            </h1>
            <p className="text-gray-600">Manage chart of accounts, banks, vendors, expenses, assets, and reports</p>
          </div>

          <div className="bg-white rounded-lg shadow-sm border border-gray-200">
            <div className="border-b border-gray-200">
              <nav className="flex space-x-8 px-6 overflow-x-auto" aria-label="Tabs">
                {accountingTabs.map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => setActiveSubTab(tab.id)}
                    className={`${activeSubTab === tab.id ? 'border-[#2D869C] text-[#2D869C]' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'} whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition-colors duration-200`}
                  >
                    <Icon name={tab.icon} size={16} />
                    <span>{tab.label}</span>
                  </button>
                ))}
              </nav>
            </div>
            <div className="p-6">
              <Current />
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AccountingPage;
